import PropTypes from 'prop-types';
import classnames from 'classnames';
import React, { Children } from 'react';

import Dropdown from '../Dropdown';
import Icon, { GLYPHS } from '../icon';
import { t } from '../../../modules/infra/i18n';

const renderChildren = (props) => {
  if (!props.isOpen) return [];

  return Children.map(props.children, child => (
    child
      ? (
        <Dropdown.Item
          key={child.key}
          onMouseEnter={props.handleMouseEnter}
          onMouseLeave={props.handleMouseLeave}
        >
          {child}
        </Dropdown.Item>
      )
    : null
  ));
};

const DropdownMenu = props => (
  <button
    className={classnames('c-dropdown-menu', props.className, { 'is-open': props.isOpen })}
    type="button"
    onMouseLeave={props.handleMouseLeave}
    onMouseEnter={props.handleMouseEnter}
    onClick={props.handleClick}
  >
    <div className={classnames('c-dropdown-menu__label', props.labelClassName)}>
      {props.label || t('common:buttons.more')}
    </div>
    <div className="c-dropdown-menu__icon" display-if={props.showIcon}>
      <Icon glyph={GLYPHS.chevronDropdown} size="micro" />
    </div>
    <div className="c-dropdown-menu__menu">
      <Dropdown width={props.width} alignment={props.alignment}>
        {renderChildren(props)}
      </Dropdown>
    </div>
  </button>
);

DropdownMenu.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  showIcon: PropTypes.bool,
  labelClassName: PropTypes.string,
  handleMouseLeave: PropTypes.func.isRequired,
  handleMouseEnter: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  width: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'right']),
  isOpen: PropTypes.bool.isRequired,
};

DropdownMenu.defaultProps = {
  className: '',
  label: '',
  showIcon: true,
  labelClassName: '',
  width: '',
  alignment: 'right',
};

export default DropdownMenu;
